var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.value),function(item,index){return _c(`section-${item.type}`,{key:index,tag:"component",attrs:{"value":item}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }